var EMPTY = [];
export function shouldRecreatePreset(props, nextProps) {
  var _props$dangerouslyApp, _props$dangerouslyApp2, _nextProps$dangerousl, _nextProps$dangerousl2;
  var prevPlugins = (_props$dangerouslyApp = (_props$dangerouslyApp2 = props.dangerouslyAppendPlugins) === null || _props$dangerouslyApp2 === void 0 ? void 0 : _props$dangerouslyApp2.__plugins) !== null && _props$dangerouslyApp !== void 0 ? _props$dangerouslyApp : EMPTY;
  var nextPlugins = (_nextProps$dangerousl = (_nextProps$dangerousl2 = nextProps.dangerouslyAppendPlugins) === null || _nextProps$dangerousl2 === void 0 ? void 0 : _nextProps$dangerousl2.__plugins) !== null && _nextProps$dangerousl !== void 0 ? _nextProps$dangerousl : EMPTY;
  if (nextPlugins.length !== prevPlugins.length || prevPlugins.some(function (p) {
    return nextPlugins.some(function (n) {
      return n.name === p.name && n !== p;
    });
  })) {
    return true;
  }
  return shouldReconfigureState(props, nextProps);
}
function shouldReconfigureState(props, nextProps) {
  var mobileProperties = props.appearance === 'mobile' ? ['quickInsert', 'featureFlags'] : [];
  var properties = ['appearance', 'persistScrollGutter', 'allowUndoRedoButtons', 'placeholder', 'sanitizePrivateContent'].concat(mobileProperties);
  return properties.reduce(function (acc, curr) {
    return acc || props[curr] !== nextProps[curr];
  }, false);
}